import { render, staticRenderFns } from "./SummaryBsEcoFull.vue?vue&type=template&id=aad304e0&"
import script from "./SummaryBsEcoFull.vue?vue&type=script&lang=js&"
export * from "./SummaryBsEcoFull.vue?vue&type=script&lang=js&"
import style0 from "./SummaryBsEcoFull.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VContainer,VOverlay,VProgressCircular,VSpacer,VToolbar})
